import { render, staticRenderFns } from "./PatientUserInfo.vue?vue&type=template&id=a36a192e&scoped=true"
import script from "./PatientUserInfo.vue?vue&type=script&lang=js"
export * from "./PatientUserInfo.vue?vue&type=script&lang=js"
import style0 from "./PatientUserInfo.scss?vue&type=style&index=0&id=a36a192e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a192e",
  null
  
)

export default component.exports